// extracted by mini-css-extract-plugin
module.exports = {"card":"customPages_card__2pWGt","draggable":"customPages_draggable__2QOWw"};